import type { OverviewMenuId } from '../../types'
import { useOverviewStore } from '../../stores/overview'
import { computed, type ComputedRef } from 'vue'
import { getPageByMenu } from '../../helpers/getPageByMenu'

interface UseMenuOverview {
  currentMenu: ComputedRef<OverviewMenuId>
  doSelectMenu: (menu: OverviewMenuId) => void
}

//------------------------------------------------
export function useMenuOverview(): UseMenuOverview {
  const overviewStore = useOverviewStore()

  const currentMenu = computed(() => overviewStore.menu)

  function doSelectMenu(menu: OverviewMenuId) {
    const page = getPageByMenu(menu)
    overviewStore.setActivePage(page)
    overviewStore.slideToActivePage()
  }

  return {
    currentMenu,
    doSelectMenu,
  }
}

//------------------------------------------------
export function useMenuOverviewMock(): UseMenuOverview {
  const currentMenu = computed(() => 'menu2' as OverviewMenuId)

  function doSelectMenu(menu: OverviewMenuId) {
    console.debug('doSelectMenu()', { menu })
  }

  return {
    currentMenu,
    doSelectMenu,
  }
}
